import React from "react";
import styled from "styled-components";
import { ReactComponent as HeavenLogo } from "../../global/assets/heavenhr-logo.svg";

export const SignInContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.colors.misc3};
  padding-top: max(10%, 120px);
  height: calc(100% + max(10%, 120px));
`;

const LoginBox = styled.div`
  width: 20%;
  min-width: 300px;
  min-height: 380px;
  padding: 20px;
  margin: auto;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(var(--b6a, 219, 219, 219), 1);
  border-radius: 1px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const LogoContainer = styled.div`
  flex: 0.2;
  justify-content: center;
  width: 170px;
  margin: 30px auto auto;
`;

const FormContainer = styled.div`
  flex: 0.8;
  position: relative;
`;

interface PublicWrapperProps {
  children: React.ReactNode;
}

const PublicWrapper = (props: PublicWrapperProps): React.ReactElement => {
  return (
    <SignInContainer>
      <LoginBox>
        <LogoContainer>
          <HeavenLogo />
        </LogoContainer>
        <FormContainer>{props.children}</FormContainer>
      </LoginBox>
    </SignInContainer>
  );
};

export default PublicWrapper;
